import { ListedPropertyRoomGetAssessmentDetail } from '../CU-033-01/models/Property';

export const convertDataToForm = (data: ListedPropertyRoomGetAssessmentDetail) => {
    return {
        balconyArea: data.balconyArea,
        bathToiletSeparatedDiv: data.bathToiletSeparatedDiv,
        commonServiceFee: data.commonServiceFee,
        indoorLaundryRoomDiv: data.indoorLaundryRoomDiv,
        loanBalance: data.loanBalance,
        managementFee: data.managementFee,
        notes: data.notes,
        occupiedArea: Number(data.occupiedArea),
        occupiedFloor: data.occupiedFloor,
        otherExpenses: data.otherExpenses,
        otherExpensesNotes: data.otherExpensesNotes,
        ownshipYear: data.ownshipYear,
        presentCondDiv: data.presentCondDiv,
        renovationDeposit: data.renovationDeposit,
        rent: data.rent,
        roomLayoutDiv: data.roomLayoutDiv,
        roomNumber: data.roomNumber,
        image: data?.propertyImages?.[0]?.imageFilePath,
    };
};
